import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function DispositivoForm(props: any){
    const methods = useForm({
        defaultValues: props.data || {}
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={6} name="usuario.pessoa.nome" label="Usuário" readOnly/>
                        <UiInputCheckbox size={2} name="ativo" label="Ativo" disabled/>
                        <UiInputText size={4} name="ultimoAcesso" label="Último Acesso" readOnly/>
                        <UiInputText size={6} name="usuario.codigoQr" label="Código do QR" readOnly/>
                        <UiInputText size={6} name="usuario.perfil.nome" label="Perfil" readOnly/>
                        <UiInputText size={6} name="apelido" label="Apelido" readOnly/>
                        <UiInputText size={6} name="modelo" label="Modelo" readOnly/>
                        <UiInputText size={6} name="plataforma" label="Plataforma" readOnly/>
                        <UiInputText size={6} name="versaoApp" label="Versão do App" readOnly/>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
